import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Emdash from '@components/shared/Emdash/Emdash';
import { SpaceCondition } from '@root/types';

type Props = {
  condition: SpaceCondition | null;
};

const SpaceConditionCell: React.FC<Props> = ({ condition = null }) => {
  const { t } = useTranslation();

  if (!condition) {
    return <Emdash muted />;
  }

  return condition ? t(`spaceConditions:${condition}`) : null;
};

export default SpaceConditionCell;
